import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import SelectMultiple from 'components/SelectMultiple';
import ChipInput from 'material-ui-chip-input';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { run } from 'validations/ruleRunner';

import Item from './Item';
import SelectTree from './SelectTree';
import styles from './styles';
import Tags from './Tags';
import Validations from './validations';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  onChange?: any;
  onApply?: any;
  filter: any;
  active: boolean;
  classes?: any;
  disabled?: boolean;
}
interface IStates {
  selectedFilter: any;
  selectedValues: any;
  typeField: 'single' | 'multiple' | 'text' | 'checkbox' | 'multiple-text' | 'customer' | 'select-tree';
  customerFilter: any;
  validationErrors: any;
  validationType?: 'email' | 'document';
  placeholder?: string;
  helperText?: string;
  clearInput?: boolean;
}
class FilterTags extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      selectedFilter: 'none',
      selectedValues: null,
      typeField: 'text',
      customerFilter: 'email',
      validationErrors: {},
      clearInput: false,
    };
  }

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  onChangeCustomerFilter = async (e: any) => {
    await this.setState({ customerFilter: e.target.value, selectedValues: null, validationErrors: {} });
  };

  onChangeFilterType = (e: any) => {
    this.setState({ selectedFilter: e.target.value, selectedValues: null, validationErrors: {} }, () => {
      this.renderFilterInput();
    });
  };

  onAddFilter = () => {
    (async () => {
      try {
        let filter = {};
        const props = this.getChildrenItems(this.props.children);
        const selected = props.find((it: any) => it.name === this.state.selectedFilter);
        let prop = selected.tagLabel || selected.name;
        let old = [];
        let { selectedValues } = this.state;
        if (selected.type === 'multiple-text') {
          selectedValues = selectedValues.map((item: any) => ({ label: item, value: item }));
        }
        if (prop === 'Cliente') {
          let pname = this.state.customerFilter;
          prop = pname === 'email' ? 'Email do cliente' : pname === 'name' ? 'Nome do cliente' : 'CPF/CNPJ do cliente';
          let value = selectedValues;
          if (prop === 'Nome do cliente') {
            selectedValues = { label: value, value };
          } else {
            selectedValues = [];
            selectedValues.push({ label: value, value });
          }
        }
        if (this.props.filter[prop] && Array.isArray(this.props.filter[prop])) {
          old = this.props.filter[prop].filter((item: any) => {
            for (let i = 0; i < selectedValues.length; i++) {
              if (selectedValues[i].value === item.value) {
                return false;
              }
            }
            return true;
          });
        }
        filter[prop] = Array.isArray(selectedValues) ? [...selectedValues, ...old] : selectedValues;
        await this.props.dispatch({ type: 'ADD_FILTER_TAG', filter });
        this.setState({ selectedValues: null, clearInput: true }, () => {
          this.setState({ clearInput: false });
        });
        if (this.props.onChange) {
          this.props.onChange();
        }
      } catch (error) {}
    })();
  };

  getChildrenItems = (children: any) => {
    return React.Children.map(children, (child: any) => {
      return child.props;
    });
  };

  onChangeSelectedValues = async (values: any, validation?: string) => {
    let validationErrors: any = {};
    if (validation) {
      let object = {};
      object[validation] = values;
      validationErrors = run(object, Validations);
    }
    await this.setState({ selectedValues: values, validationErrors });
  };

  onChangeValueEmail = (e: any) => this.onChangeSelectedValues(e.target.value, 'email');
  onChangeValueName = (e: any) => this.onChangeSelectedValues(e.target.value);
  onChangeValueDocument = (e: any) => this.onChangeSelectedValues(e.target.value);
  renderFilterInput = () => {
    const { children } = this.props;
    try {
      const items: any = this.getChildrenItems(children);
      const item: any = items.find((it: any) => it.name === this.state.selectedFilter);
      if (item) {
        if (item.action) {
          this.props.dispatch(item.action());
        }
      }
    } catch (error) {
      toast.error('Ops! Ocorreu um erro no filtro!');
    }
  };

  handleAddChip = (value: any) => {
    this.setState({ selectedValues: [...(this.state.selectedValues || []), value] });
  };

  handleDeleteChip = (value: any, index: number) => {
    const selectedValues = this.state.selectedValues || [];
    selectedValues.splice(index, 1);

    this.setState({ selectedValues });
  };

  componentWillUnmount() {
    this.props.dispatch({ type: 'RESET_FILTER_TAG' });
  }

  render() {
    const { children, classes, onChange, onApply, disabled } = this.props;
    const { selectedFilter, selectedValues } = this.state;
    const props = this.getChildrenItems(children);
    const selected = props.find((it: any) => it.name === selectedFilter);
    const onChangeSelectedValue = (e: any) => this.onChangeSelectedValues(e.target.value, selected.validationType);

    if (!this.props.active) {
      return null;
    } else {
      return (
        <div className={classes.filterInputs}>
          <Grid container spacing={2}>
            <Grid xs={12} sm={12} md={3} item>
              <TextField
                select
                fullWidth
                value={selectedFilter}
                placeholder={'Selecione um tipo de filtro'}
                onChange={this.onChangeFilterType}
                InputProps={{
                  disableUnderline: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={disabled}
              >
                <MenuItem value={'none'} disabled>
                  Selecione um tipo de filtro
                </MenuItem>
                {props &&
                  props.map((item: any) => (
                    <MenuItem key={'filter' + item.name} value={item.name}>
                      {item.name}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>
            <Grid xs={12} sm={7} md={7} item>
              {selected && selected.type === 'multiple' && (
                <SelectMultiple
                  label={selected.name}
                  value={selectedValues}
                  placeholder={!selected.options || selected.options.isFetching ? 'Carregando...' : `Informe um ou mais ${selected.name}`}
                  classes={{
                    placeholder: classes.placeholderMultiple,
                  }}
                  disabled={selected.options && selected.options.isFetching}
                  noOptionsMessage={'Não existe itens a serem mostrados'}
                  onChange={this.onChangeSelectedValues}
                  options={!selected || !selected.options || !Array.isArray(selected.options) || selected.options.isFetching ? [] : selected.options}
                  itemLabel={selected.label}
                  itemValue={selected.value}
                />
              )}
              {selected && selected.type === 'multiple-text' && (
                <ChipInput
                  disableUnderline
                  format={selected.format}
                  classes={{ chipContainer: classes.chipContainer, input: classes.chipInput, chip: classes.chipRoot }}
                  value={selectedValues || []}
                  fullWidth
                  placeholder={`Informe ${selected.name}`}
                  blurBehavior='add'
                  onDelete={this.handleDeleteChip}
                  onAdd={this.handleAddChip}
                  allowDuplicates={false}
                />
              )}
              {selected && selected.type === 'single' && (
                <TextField
                  select
                  value={selectedValues || null}
                  fullWidth
                  placeholder={
                    !selected.options || selected.options.isFetching ? 'Carregando...' : selected.placeholder ? selected.placeholder : 'Selecione...'
                  }
                  onChange={(e: any) => this.onChangeSelectedValues(e.target.value)}
                >
                  {selected.options.map((op: any, index: any) => (
                    <MenuItem key={`${index}-${op}`} value={op}>
                      {selected.label ? op[selected.label] : op}
                    </MenuItem>
                  ))}
                </TextField>
              )}
              {selected && selected.type === 'text' && (
                <TextField
                  value={selectedValues || ''}
                  error={this.isValid(selected.validationType)}
                  helperText={
                    this.isValid(selected.validationType) ? this.errorFor(selected.validationType) : selected.helperText ? selected.helperText : ''
                  }
                  placeholder={selected.placeholder ? selected.placeholder : ''}
                  fullWidth
                  onChange={onChangeSelectedValue}
                  InputProps={{
                    disableUnderline: true,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
              {selected && selected.type === 'customer' && (
                <div>
                  <TextField
                    select
                    placeholder={'Cliente'}
                    style={{ width: '30%' }}
                    value={this.state.customerFilter}
                    onChange={this.onChangeCustomerFilter}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  >
                    <MenuItem value='email'>Email</MenuItem>
                    <MenuItem value='name'>Nome</MenuItem>
                    <MenuItem value='cpfCnpj'>CPF/CNPJ</MenuItem>
                  </TextField>
                  {this.state.customerFilter === 'email' ? (
                    <TextField
                      fullWidth
                      style={{ width: '70%' }}
                      helperText={this.isValid('email') ? this.errorFor('email') : ''}
                      value={selectedValues || ''}
                      error={this.isValid('email')}
                      placeholder={'Informe o email do cliente'}
                      onChange={this.onChangeValueEmail}
                    />
                  ) : this.state.customerFilter === 'name' ? (
                    <Input
                      fullWidth
                      style={{ width: '70%' }}
                      value={selectedValues || ''}
                      placeholder='Informe o nome do cliente'
                      onChange={this.onChangeValueName}
                    />
                  ) : this.state.customerFilter === 'cpfCnpj' ? (
                    <Input
                      fullWidth
                      style={{ width: '70%' }}
                      value={selectedValues || ''}
                      placeholder='Informe o CPF/CPNJ do cliente'
                      onChange={this.onChangeValueDocument}
                    />
                  ) : null}
                </div>
              )}
              {selected && selected.type === 'select-tree' && (
                <React.Fragment>
                  <SelectTree
                    loading={selected.options.isFetching}
                    onChange={this.onChangeSelectedValues}
                    options={selected.options}
                    itemLabel={selected.label}
                    itemValue={selected.value}
                    clearInput={this.state.clearInput}
                  />
                </React.Fragment>
              )}
            </Grid>
            <Grid xs={12} sm={5} md={2} item>
              <div style={{ textAlign: 'right', lineHeight: 1 }}>
                <Button
                  disabled={
                    !selectedValues ||
                    (selected.validationType && this.isValid(selected.validationType)) ||
                    (selected.type === 'customer' && this.isValid('email')) ||
                    disabled
                  }
                  fullWidth
                  variant='contained'
                  color='primary'
                  onClick={this.onAddFilter}
                >
                  <Icon style={{ fontSize: 14, marginRight: 8 }}>add</Icon>
                  Adicionar
                </Button>
              </div>
            </Grid>
            <Grid item xs={12}>
              <Tags onChange={onChange} onApply={onApply} disabled={disabled} />
            </Grid>
          </Grid>
        </div>
      );
    }
  }
}

function mapStateToProps(state: any) {
  return {
    filter: state.components.FilterTag.filter,
  };
}

export { Item };

export default connect(mapStateToProps)(styles(FilterTags));
